var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "topic" }, [
    _c(
      "div",
      { staticClass: "topic-wrap" },
      [
        _c("billboards", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.billboardsList.length,
              expression: "billboardsList.length",
            },
          ],
          ref: "billboard",
          attrs: { billboardList: _vm.billboardsList },
        }),
        _vm._v(" "),
        _c("recommend", {
          ref: "recommend",
          attrs: {
            recommendList: _vm.recommendList,
            myStyle: "padding-bottom:15px;",
          },
          on: { "click-icon": _vm.clickRecommend },
        }),
        _vm._v(" "),
        !_vm.getProductError || _vm.goodsListFormat.length
          ? _c(
              "div",
              {
                ref: "topicBar",
                staticClass: "topic-bar border-radius-8",
                class: [
                  _vm.isScrollFixBar,
                  _vm.isShowAllMenus ? "z-index-0" : "",
                ],
              },
              [
                _c(
                  "div",
                  {
                    class: ["default"].concat(_vm.defaultClass),
                    on: {
                      click: function ($event) {
                        return _vm.sortByDefault()
                      },
                    },
                  },
                  [_c("span", [_vm._v("推荐")])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: ["salesCount"].concat(_vm.salesCountClass),
                    on: {
                      click: function ($event) {
                        return _vm.sortBySalesCount()
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v("销量")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "icon-content" },
                      [
                        _c(
                          "icon",
                          { attrs: { size: "12", color: "rgb(189,192,197)" } },
                          [_vm._v("sousuo-paixujiantoushang")]
                        ),
                        _vm._v(" "),
                        _c(
                          "icon",
                          { attrs: { size: "12", color: "rgb(189,192,197)" } },
                          [_vm._v("sousuo-paixujiantouxia")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: ["price"].concat(_vm.priceClass),
                    on: {
                      click: function ($event) {
                        return _vm.sortByPrice()
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v("价格")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "icon-content" },
                      [
                        _c(
                          "icon",
                          { attrs: { size: "12", color: "rgb(189,192,197)" } },
                          [_vm._v("sousuo-paixujiantoushang")]
                        ),
                        _vm._v(" "),
                        _c(
                          "icon",
                          { attrs: { size: "12", color: "rgb(189,192,197)" } },
                          [_vm._v("sousuo-paixujiantouxia")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.getProductError || _vm.goodsListFormat.length
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "infinite-scroll",
                    rawName: "v-infinite-scroll",
                    value: _vm.loadMore,
                    expression: "loadMore",
                  },
                ],
                staticClass: "topic-list clearfix",
                attrs: {
                  "infinite-scroll-disabled": _vm.loading,
                  "infinite-scroll-distance": "50",
                },
              },
              [
                _c("goods-list", {
                  attrs: {
                    goodsList: _vm.goodsListFormat,
                    viewTrackData: _vm.viewTrackData,
                    showType: _vm.$attrs.showType,
                  },
                  on: { "click-goods-item": _vm.clickItem },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowNoMore
          ? _c("div", { staticClass: "no-more" }, [_vm._v("- 我是有底线的 -")])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isShowNoMore,
                expression: "!isShowNoMore",
              },
            ],
            staticClass: "page-infinite-loading",
            class: { "page-loading-visible": !_vm.loading },
          },
          [
            _c("mt-spinner", { attrs: { type: "fading-circle" } }),
            _vm._v("\n        加载中...\n      "),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }